import React, {useEffect, useState} from 'react';
import {Button, Input,Form,message } from "antd";
import {login,getUserPerms,signUp,sendVeriCodeToPhone,sendVeriCodeToEmail} from '../../api/user'
import './index.css'
import { useSelector,useDispatch } from 'react-redux';
import {setAllContextMeta, setAuthId, setUserInfo} from '../../store/modules/user'
import {getAllContextMeta} from "../../api/other";
//登录/注册
const LoginApp =(props)=>{
    //父组件传输
    const {handleLoginModelOk,handleCancelModel} = props
    //缓存
    const {userInfo,authId} = useSelector(state=>state.user)
    const dispatch = useDispatch()
    //注册/登录 判定字段 0-登录  1-注册
    const [modeIndex,setModeIndex] = useState(0)
    //手机号注册/邮箱注册 0-手机号 1-邮箱
    const [resIndex,setResIndex] = useState(0)
    //验证码文案
    const [codeTxt,setCodeTxt] = useState('发送验证码')
    const [count, setCount] = useState(0);
    //所有语境
    const getAllContextMetas =()=>{
        getAllContextMeta().then(res=>{
            if(res.code === 200){
                dispatch(setAllContextMeta(res.data))
            }
        })
    }
    // 登录/注册 事件
    //form组件
    const [form] = Form.useForm();
    const onFinish = (values) => {
        //登录
        if(modeIndex===0){
            login(values).then(res=>{
                if(res.code === 200){
                    dispatch(setAuthId(res.data['auth-id']))
                    message.success('登录成功');
                    handleCancelModel()
                    formReset()
                    //登陆成功后 获取用户信息存入缓存
                    getUserPerms().then(userInfo=>{
                        if(userInfo.code === 200){
                            dispatch(setUserInfo(userInfo.data))
                        }
                    })
                    getAllContextMetas()
                    setTimeout(()=>{window.location.reload()},500)
                }
            })
        }else{
        //    注册
            let signUpData = values;
            signUpData['sign_up_type'] = resIndex===0?'phone':'email'
            signUp(signUpData).then(res=>{
                if(res.code === 200){
                    dispatch(setAuthId(res.data['auth-id']))
                    message.success('注册成功');
                    handleCancelModel()
                    formReset()
                    //登陆成功后 获取用户信息存入缓存
                    getUserPerms().then(userInfo=>{
                        if(userInfo.code === 200){
                            dispatch(setUserInfo(userInfo.data))
                        }
                    })
                    getAllContextMetas()
                    setTimeout(()=>{window.location.reload()},500)
                }
            })
        }

    };
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //重置内容
    const formReset = ()=>{
        form.resetFields()
    }
    //发送验证码
    const handleSendCode = ()=>{
        let phone_or_email = form.getFieldsValue()['phone_or_email']
        if(!phone_or_email){
            message.error('请先输入正确的手机号/邮箱再尝试获取验证码')
            return false
        }
        if(
            !(new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g')).test(phone_or_email)&&
            !(new RegExp(/^1\d{10}$/, 'g')).test(phone_or_email)
        ){
            message.error('请先输入正确的手机号/邮箱再尝试获取验证码')
            return false
        }
        handleVerCode()
        if(resIndex===0){
            sendVeriCodeToPhone({phone_or_email}).then(res=>{
                if(res.code===200){
                    message.success('验证码已发送')
                }
            })
        }else{
            sendVeriCodeToEmail({phone_or_email}).then(res=>{
                if(res.code===200){
                    message.success('验证码已发送')
                }
            })
        }
    }
    useEffect(() => {
        if (count !== 0) {
            setTimeout(()=>{
                let counter = count
                counter--
                console.log(counter)
                setCount(counter);
            },1000)
        }
    }, [count]);
    const handleVerCode = ()=>{
        let counter = 60; // 倒计时60秒
        setCount(counter);
    }
    return (
        <div className="loginApp">
            <div className='mode'>
                <span onClick={()=>setModeIndex(0)} className={modeIndex===1?'c':''}>登录</span>
                <font onClick={()=>setModeIndex(1)} className={modeIndex===0?'c':''}>注册</font>
            </div>
            {
                modeIndex===0?
                <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                    <div className='fL'>用户名/手机号/邮箱</div>
                    <div>
                        <Form.Item
                            label=""
                            name="user"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入用户名/手机号/邮箱',
                                },
                            ]}
                        >
                            <Input placeholder="username / phone number / email" size="large"/>
                        </Form.Item>
                    </div>
                    <div className='fL'>密码</div>
                    <div>
                        <Form.Item label="" name="password"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入密码',
                                       },
                                   ]}
                        >
                            <Input.Password placeholder="password" size="large"/>
                        </Form.Item>
                    </div>
                    <Form.Item>
                        <div className='textCenter'>
                            <Button className='selfBtn' htmlType="submit">
                                登录
                            </Button>
                            <Button className='selfBtn btn2' onClick={handleCancelModel}>
                                取消
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
                    :
                <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                    <div className='fL'>用户名</div>
                    <div>
                        <Form.Item
                            label=""
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入用户名',
                                },{
                                    pattern: new RegExp(/^[A-Za-z0-9\_\-]{4,32}$/, 'g'),
                                    message: '请输入4位以上,32以下字符的用户名'
                                }
                            ]}
                        >
                            <Input placeholder="长度4-32 仅支持 _ 0-9 a-z A-Z" size="large"/>
                        </Form.Item>
                    </div>
                    <div className='fL'>密码</div>
                    <div>
                        <Form.Item label="" name="password"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入密码',
                                       },{
                                           pattern: new RegExp(/^[A-Za-z0-9\_\-]{4,32}$/, 'g'),
                                           message: '请输入4位以上,32以下字符的密码'
                                       }
                                   ]}
                        >
                            <Input.Password placeholder="长度4-32 仅支持 _ 0-9 a-z A-Z" size="large"/>
                        </Form.Item>
                    </div>
                    <div className='fL mode'>
                        <span onClick={()=>setResIndex(0)} className={resIndex===1?'c':''}>手机号</span>
                        <font onClick={()=>setResIndex(1)} className={resIndex===0?'c':''}>邮箱</font>
                    </div>
                    {
                        resIndex===0?
                        <Form.Item label="" name="phone_or_email"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入手机号',
                                       },{
                                           pattern: new RegExp(/^1\d{10}$/, 'g'),
                                           message: '请输入正确的手机号'
                                       }
                                   ]}
                        >
                            <Input placeholder="暂时仅支持中国大陆手机号" size="large"/>
                        </Form.Item>
                            :
                        <Form.Item label="" name="phone_or_email"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输邮箱',
                                                    },{
                                                        pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g'),
                                                        message: '请输入正确的邮箱'
                                                    }
                                                ]}
                        >
                            <Input placeholder="暂时仅支持国内邮箱，如qq,163等" size="large"/>
                        </Form.Item>
                    }
                    <div className='fL'>验证码</div>
                    <div className='dp'>
                        <Form.Item label="" name="veri_code"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入验证码',
                                       }
                                   ]}
                        >
                            <Input placeholder="验证码" size="large" className='widthSmall'/>
                        </Form.Item>
                        <Button disabled={count!==0} size="large" className='sbtn selfBtn btn2' onClick={handleSendCode}>{count===0?'发送验证码':count}</Button>
                    </div>

                    <Form.Item>
                        <div className='textCenter'>
                            <Button className='selfBtn' htmlType="submit">
                                注册
                            </Button>
                            <Button className='selfBtn btn2' onClick={handleCancelModel}>
                                取消
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            }
        </div>
    )
}

export default LoginApp
